import * as NumberExt from './number';
export { NumberExt };
//# sourceMappingURL=index.js.map